/* st-form.js — submit feedback for custom Shopify contact forms (contact + ambassador).
   No dependencies. Scoped to forms carrying class "st-cform" so it never touches
   AJAX product forms (st-atc.js) or Horizon-core forms. Idempotent: safe to load twice. */
(function () {
  'use strict';
  if (window.__stFormInit) return;
  window.__stFormInit = true;

  function onSubmit(e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('st-cform')) return;

    var btn = form.querySelector('button[type="submit"], button:not([type])');
    if (!btn || btn.dataset.stSending === '1') return;

    // let the native POST proceed; just reflect the sending state
    btn.dataset.stSending = '1';
    if (!btn.dataset.stLabel) btn.dataset.stLabel = btn.innerHTML;
    btn.setAttribute('aria-disabled', 'true');
    btn.disabled = true;
    var sending = btn.getAttribute('data-sending-label') || 'Sending…';
    btn.innerHTML = sending;
  }

  document.addEventListener('submit', onSubmit, true);
})();
